import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { of } from 'rxjs';

import { Order } from '../../../models/order.model';
import { MobileCheckServiceService } from '../../../services/mobile-check-service.service';
import { OrderService } from '../../../services/order.service';

@Component({
  selector: 'app-order-info',
  templateUrl: './order-info.component.html',
  styleUrls: ['./order-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class OrderInfoComponent implements OnInit {
  @Input() order: Order;
  @Input() orderStatus = '';

  $isInvoiceExistsForOrder = of(false);

  constructor(
    private orderService: OrderService,
    private mobileCheck: MobileCheckServiceService
  ) {}

  ngOnInit(): void {
    this.$isInvoiceExistsForOrder = this.orderService.isInvoiceExistsForOrder(
      this.order.id
    );
  }

  onExportToPDF(): void {
    window.open(
      `${this.orderService.getApiUrl()}/${this.order.id}/pdf`,
      '_blank'
    );
  }

  onExportToExcel(): void {
    window.open(
      `${this.orderService.getApiUrl()}/${this.order.id}/xlsx`,
      '_blank'
    );
  }

  onDownloadInvoiceExcel(): void {
    window.open(
      `${this.orderService.getApiUrl()}/${this.order.id}/invoices/download`,
      '_blank'
    );
  }

  get paymentMethod(): string {
    if (!this.order) {
      return '';
    }

    return this.order.creditCard ? 'Credit Card' : 'Terms';
  }

  get status(): string {
    return this.orderStatus || this.order.stateDescription;
  }

  get mobileDevice(): boolean {
    return this.mobileCheck.mobileDevice;
  }
}
